import { useStateContext } from '@xkit-yx/im-kit-ui'
import { Badge } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import { redux } from '../../general'

export default function ChatBadge(props) {

  const { store, nim } = useStateContext()
  const [allUnread, setAllUnread] = useState(0)

  const accumulatedUnread = () => {
    let unread = 0
    const key = `chat-mute-list-${localStorage.getItem('yx_account')}`
    if (!localStorage.getItem(key)) {
      store.sessionStore.sessions.forEach((session, key) => {
        unread += session.unread
      })
      setAllUnread(unread)
      return
    }
    const sessionStr = localStorage.getItem(key)
    const muteSession = JSON.parse(sessionStr)
    store.sessionStore.sessions.forEach((session, key) => {
      if (!muteSession.includes(session.id.split('-')[1])) {
        unread += session.unread
      }
    })
    // if (unread != allUnread) {
    //   setAllUnread(unread)
    // }
    setAllUnread(unread)
  }

  useEffect(()=>{
    setTimeout(() => {
      accumulatedUnread()
    }, 1000);
  },[])

  useEffect(() => {    

    nim.on('msg', () => {
      accumulatedUnread()
    })

    redux.subscribe(() => {
      let clearChatUnRead = redux.getState().clearChatUnRead;
      if (clearChatUnRead) {
        setAllUnread(0)
      }
    })

    redux.subscribe(() => {
      let updateChatUnread = redux.getState().updateChatUnread;
      if (updateChatUnread) {
        accumulatedUnread()
      }
    })

  }, [])

  return (
    <div style={{ position: 'fixed', bottom: 'calc(env(safe-area-inset-bottom) + 40px)', left: '31%', zIndex: '101', height: '14px' }}>
      <Badge content={allUnread > 99 ? '99+' : allUnread} style={{
        '--right': '20px', '--top': '-17px',minWidth:'14px',
        display: (parseInt(allUnread) == 0 ? 'none' : '')
      }}></Badge>
    </div>
  )
}
